import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'

const InvoiceItemUpdateModalUI = ({ context, messageList, successMsg, errorList, setErrorList, invoice,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onRowClick, onCancelClick,
  // order item id
  orderItemList
}) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_update_invoice'
    buttonMessageKey='c_update'
    cancelMessageKey='c_cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <LRTableBodyUI>
      {
        orderItemList && orderItemList
        .filter(item => !item.customerInvoiceId || item.customerInvoiceId === invoice.customerInvoiceId)
        .map((item, i) =>
          <OrderItemRowUI key={i} context={context} item={item}
            messageList={messageList} onRowClick={onRowClick}
          />
        )
      }
    </LRTableBodyUI>
  </ModalFormUI>


const OrderItemRowUI = ({ context, item, messageList, onRowClick }) =>
  <LRTableRowUI
    context={context}
    left={<RowLeftUI context={context} item={item} onRowClick={onRowClick} />}
    onClick={context.permissions.includes('acc_manage') ? onRowClick : null}
    rowId={item.orderItemId}
  />

const RowLeftUI = ({ context, item, onRowClick }) =>
  <React.Fragment>
    {/* if React.Fragment is replaced with html element
      must add flex to the html element */}
    {
      context.permissions.includes('acc_manage') &&
      <input type="checkbox" className={`checkbox item`}
        checked={item.selected} onChange={() => { }}
      />
    }
    <label className='name'>
      {item.itemName}
    </label>
  </React.Fragment>


export default InvoiceItemUpdateModalUI
